"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4117,5909],{

/***/ 24117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _services_promoCodes_promo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15890);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_addParamsToUrl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54552);
/* harmony import */ var _hooks_DmpAnalytics_pushDMPAnalyticsEvent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15909);









var Row = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(__webpack_require__.e(/* import() */ 9323).then(__webpack_require__.bind(__webpack_require__, 69323)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69323)
            ];
        }
    }
});
var ProductTile = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(Promise.all(/* import() */[__webpack_require__.e(3996), __webpack_require__.e(7202)]).then(__webpack_require__.bind(__webpack_require__, 27202)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27202)
            ];
        }
    }
});
var AddToWishList = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(__webpack_require__.e(/* import() */ 2524).then(__webpack_require__.bind(__webpack_require__, 62524)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62524)
            ];
        }
    }
});
var PLPProducts = function(param) {
    var products = param.products, _cols = param.cols, cols = _cols === void 0 ? 3 : _cols, isFreeRugDoorstepShippingOn = param.isFreeRugDoorstepShippingOn, user = param.user, reloadCustomer = param.reloadCustomer, plpSource = param.plpSource, plpSourceId = param.plpSourceId, pageNumber = param.pageNumber;
    var isPromoEnabled = _services_promoCodes_promo__WEBPACK_IMPORTED_MODULE_3__/* .promoLocallyEnabled */ .p4;
    var isTurnToEnabled = _services_Configuration__WEBPACK_IMPORTED_MODULE_2__.FEATURE_TOGGLES === null || _services_Configuration__WEBPACK_IMPORTED_MODULE_2__.FEATURE_TOGGLES === void 0 ? void 0 : _services_Configuration__WEBPACK_IMPORTED_MODULE_2__.FEATURE_TOGGLES.isTurnToEnabled;
    var getPromoData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(skus) {
        return isPromoEnabled() && skus.some(_services_promoCodes_promo__WEBPACK_IMPORTED_MODULE_3__/* .isPromoValid */ .E3) ? {
            text: (0,_services_promoCodes_promo__WEBPACK_IMPORTED_MODULE_3__/* .promoText */ .uS)(),
            code: (0,_services_promoCodes_promo__WEBPACK_IMPORTED_MODULE_3__/* .promoCode */ .n7)()
        } : undefined;
    }, [
        isPromoEnabled
    ]);
    var getCouponFromProduct = function(product) {
        var result = product.prices.variants.find(function(v) {
            return !!v.promoMessage && !!v.couponCode;
        }) || {
            promoMessage: "",
            couponCode: ""
        };
        if (result.promoMessage && result.couponCode) {
            return {
                text: result.promoMessage,
                code: result.couponCode
            };
        }
        return undefined;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, {
        cols: {
            xs: 2,
            md: cols
        },
        gapY: "xl",
        gapX: {
            xs: "md",
            md: "xl"
        },
        children: products.map(function(product, index) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductTile, {
                    imageBottomRightComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddToWishList, {
                        className: "border max-h-56 overflow-y-scroll overflow-x-hidden -left-1/2 -translate-x-1/2 -top-6 absolute transform -translate-y-full bg-white rounded-md z-1002",
                        user: user,
                        variant: {
                            productId: product.id,
                            id: (ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id,
                            sku: (ref2 = product.variants) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.sku
                        },
                        reloadCustomer: reloadCustomer
                    }),
                    lazyLoad: index > 6,
                    onImpressionEvent: function() {
                        var ref, ref1, ref2, ref3;
                        (0,_hooks_DmpAnalytics_pushDMPAnalyticsEvent__WEBPACK_IMPORTED_MODULE_6__.sendDMPAnalyticsEvent)({
                            eventType: "plp-impression",
                            items: [
                                {
                                    salePrice: (ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.sale_price,
                                    price: (ref2 = product.variants) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.price,
                                    sku: product.sku,
                                    quantity: 1
                                }
                            ],
                            context: [
                                {
                                    key: "plp_source",
                                    value: {
                                        stringValue: plpSource,
                                        numberValue: 0,
                                        booleanValue: false
                                    }
                                },
                                {
                                    key: "plp_source_id",
                                    value: {
                                        stringValue: plpSourceId,
                                        numberValue: 0,
                                        booleanValue: false
                                    }
                                },
                                {
                                    key: "plp_page",
                                    value: {
                                        stringValue: String(pageNumber),
                                        numberValue: 0,
                                        booleanValue: false
                                    }
                                },
                                {
                                    key: "plp_index",
                                    value: {
                                        stringValue: String(index),
                                        numberValue: 0,
                                        booleanValue: false
                                    }
                                }
                            ]
                        });
                    },
                    product: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, product), {
                        custom_url: {
                            url: (0,_helpers_addParamsToUrl__WEBPACK_IMPORTED_MODULE_5__/* .addParamsToUrl */ .S)(product.custom_url.url, {
                                sku: (ref4 = product.variants) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.sku,
                                plp_source: plpSource,
                                plp_source_id: plpSourceId,
                                plp_page: String(pageNumber),
                                plp_index: String(index)
                            })
                        },
                        is_free_shipping_eligible: isFreeRugDoorstepShippingOn && !product.hasDoorstepEligibleRug && product.allVariantsAreDSElligibleRugs,
                        FreeShipping: product.FreeShipping || isFreeRugDoorstepShippingOn && product.hasDoorstepEligibleRug,
                        onClearance: product.onClearance
                    }),
                    changeImageOnHover: true,
                    promoData: getPromoData(product.prices.variants.map(function(v) {
                        return v.sku;
                    })) || getCouponFromProduct(product),
                    reviewCount: isTurnToEnabled ? product.reviewCount || 0 : 0,
                    reviewRating: product.reviewRating
                })
            }, product.sku);
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PLPProducts);


/***/ }),

/***/ 54552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ addParamsToUrl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_0__);


var getUrlFromMaybUrlMaybePath = function(maybeUrlMaybePath) {
    return maybeUrlMaybePath.startsWith("http") ? maybeUrlMaybePath : "".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_0__.SHOP_ORIGIN).concat(maybeUrlMaybePath);
};
var addParamsToUrl = function(maybeUrlMaybePath, params) {
    var urlStr = getUrlFromMaybUrlMaybePath(maybeUrlMaybePath);
    var urlObj = new URL(urlStr);
    Object.entries(params).forEach(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        urlObj.searchParams.set(key, value);
    });
    return urlObj.toString();
};


/***/ }),

/***/ 15909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sendDMPAnalyticsEvent": function() { return /* binding */ sendDMPAnalyticsEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _codebuild_output_src2868718194_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src2868718194_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src2868718194_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);
/* harmony import */ var _recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30901);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48080);
/* harmony import */ var _helpers_FP__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13174);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];











var Event = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
    uuid: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    userUUID: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    date: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    eventType: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    url: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    items: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .array */ .IX)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
        sku: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
        salePrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)(),
        price: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)(),
        quantity: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)()
    })),
    context: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .array */ .IX)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
        key: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
        value: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
            stringValue: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)()),
            numberValue: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)()),
            booleanValue: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg)())
        })
    }))
});
var assertEvent = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .assertion */ .P5)(Event, "Invalid DMP Analytics Event");
var client = null;
var uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
var localStorageDMPUserUUIDKey = "dmpUserUUID";
var getLocalStorageUserUUID = function() {
    try {
        var value = localStorage.getItem(localStorageDMPUserUUIDKey);
        if (value && uuidRegex.test(value)) {
            return value;
        }
    } catch (e) {
        return null;
    }
    return null;
};
// cached userUUID to avoid calling localStorage which may throw an error
var cachedUserUUID = null;
var loadUserUUID = function(uuidGenerator) {
    if (cachedUserUUID) {
        return cachedUserUUID;
    }
    var fromLocalStorage = getLocalStorageUserUUID();
    if (fromLocalStorage) {
        cachedUserUUID = fromLocalStorage;
        return fromLocalStorage;
    }
    var generated = uuidGenerator();
    localStorage.setItem(localStorageDMPUserUUIDKey, generated);
    cachedUserUUID = generated;
    return generated;
};
var sendEventHappyPath = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_codebuild_output_src2868718194_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
        var ref, ref1, FirehoseClient, PutRecordBatchCommand, fromCognitoIdentityPool, ref2, uuidv4, getComposeAssignmentMap, trackAmplitudeFromDMPEvent, eventData, sendFirehosePromise, amplitudePromise, results;
        return _codebuild_output_src2868718194_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.all(/* import() */[__webpack_require__.e(4354), __webpack_require__.e(5330)]).then(__webpack_require__.bind(__webpack_require__, 65330)),
                            Promise.all(/* import() */[__webpack_require__.e(3601), __webpack_require__.e(3424)]).then(__webpack_require__.bind(__webpack_require__, 83601)),
                            __webpack_require__.e(/* import() */ 6578).then(__webpack_require__.bind(__webpack_require__, 46578)),
                            __webpack_require__.e(/* import() */ 5434).then(__webpack_require__.bind(__webpack_require__, 85434)),
                            __webpack_require__.e(/* import() */ 7836).then(__webpack_require__.bind(__webpack_require__, 47836)), 
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 5);
                    ref1 = ref[0];
                    FirehoseClient = ref1.FirehoseClient;
                    PutRecordBatchCommand = ref1.PutRecordBatchCommand;
                    fromCognitoIdentityPool = ref[1].fromCognitoIdentityPool;
                    ref2 = ref[2];
                    uuidv4 = ref2.v4;
                    getComposeAssignmentMap = ref[3].getComposeAssignmentMap;
                    trackAmplitudeFromDMPEvent = ref[4].trackAmplitudeFromDMPEvent;
                    eventData = assertEvent((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        url: window.location.href,
                        uuid: String(event.uuid || (uuidv4 === null || uuidv4 === void 0 ? void 0 : uuidv4())),
                        userUUID: loadUserUUID(uuidv4),
                        date: new Date().toISOString()
                    }, event), {
                        context: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(event.context).concat([
                            {
                                key: "A/B tests",
                                value: {
                                    stringValue: JSON.stringify(getComposeAssignmentMap())
                                }
                            }, 
                        ])
                    }));
                    client = client || new FirehoseClient({
                        region: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.FIREHOSE_REGION,
                        credentials: fromCognitoIdentityPool({
                            clientConfig: {
                                region: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.COGNITO_REGION
                            },
                            identityPoolId: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.COGNITO_IDENTITY_POOL_ID
                        })
                    });
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("sendDMPAnalyticsEvent: Firehose client created");
                    if (!client) {
                        _ctx.next = 25;
                        break;
                    }
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("Sending page view");
                    sendFirehosePromise = client.send(new PutRecordBatchCommand({
                        DeliveryStreamName: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.FIREHOSE_DELIVERY_STREAM_NAME,
                        Records: [
                            {
                                Data: Buffer.from(JSON.stringify(eventData))
                            }, 
                        ]
                    }));
                    amplitudePromise = trackAmplitudeFromDMPEvent(eventData);
                    _ctx.next = 22;
                    return Promise.allSettled([
                        sendFirehosePromise,
                        amplitudePromise, 
                    ]);
                case 22:
                    results = _ctx.sent;
                    results.forEach(function(result) {
                        if (result.status === "rejected") {
                            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("result", result);
                        }
                    });
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("sendDMPAnalyticsEvent: Page view sent");
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendEventHappyPath(event) {
        return _ref.apply(this, arguments);
    };
}();
var sendEventSadPath = function(err) {
    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("sendDMPAnalyticsEvent: Error sending event: ".concat(String(err)));
};
var sendDMPAnalyticsEvent = (0,_helpers_FP__WEBPACK_IMPORTED_MODULE_5__/* .thenCaught */ .HA)(sendEventHappyPath)(sendEventSadPath);


/***/ }),

/***/ 15890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E3": function() { return /* binding */ isPromoValid; },
  "n7": function() { return /* binding */ promoCode; },
  "p4": function() { return /* binding */ promoLocallyEnabled; },
  "uS": function() { return /* binding */ promoText; }
});

// EXTERNAL MODULE: ./helpers/FP.ts
var FP = __webpack_require__(13174);
;// CONCATENATED MODULE: ./statics/promo.json
var promo_namespaceObject = JSON.parse('{"fL":"30% Off One Item* with","TU":"GATHER","LK":"2024-11-08T10:00:00.000Z","ld":"2024-11-11T07:00:00.000Z","he":[""]}');
// EXTERNAL MODULE: ./helpers/isFeatureEnabled.ts
var isFeatureEnabled = __webpack_require__(965);
;// CONCATENATED MODULE: ./services/promoCodes/promo.ts



var skuSet = new Set(promo_namespaceObject.he);
var promoText = (0,FP/* constant */.a9)(promo_namespaceObject.fL);
var promoCode = (0,FP/* constant */.a9)(promo_namespaceObject.TU);
var startTime = (0,FP/* constant */.a9)(new Date(promo_namespaceObject.LK).getTime());
var endTime = (0,FP/* constant */.a9)(new Date(promo_namespaceObject.ld).getTime());
var promoLocallyEnabled = (0,FP/* constant */.a9)((0,isFeatureEnabled/* isFeatureEnabled */.cr)("promoEnabled"));
var isCurrentTimeInPromoDateRange = function() {
    var currentTime = new Date().getTime();
    return currentTime >= startTime() && currentTime <= endTime();
};
var isSkuInPromo = function(sku) {
    return sku ? skuSet.has(sku) : false;
};
var isPromoValid = (0,FP/* branch */.WY)(isSkuInPromo)(isCurrentTimeInPromoDateRange)((0,FP/* constant */.a9)(false));



/***/ })

}]);